import { AnimatePresence, motion } from 'motion/react';
import type { FC } from 'react';

import { cn } from '@hs/ui';

import type { CutdownCardUnitProps } from './types';

const SLIDE_TRANSITION = { duration: 0.28, ease: [0.4, 0, 0.2, 1] as const };

export const CutdownCardUnit: FC<CutdownCardUnitProps> = ({
  display,
  label,
  animate,
  cardSize,
  borderRadius,
  backgroundColor,
  border,
  numberColor,
  labelColor,
}) => {
  const numberHeight = Math.round(cardSize * 0.52);
  const numberFontSize = Math.round(cardSize * 0.38);
  const labelFontSize = Math.round(cardSize * 0.16);

  return (
    <div
      className={cn('flex shrink-0 flex-col items-center justify-center')}
      style={{
        width: cardSize,
        height: cardSize,
        borderRadius,
        backgroundColor,
        border,
      }}
    >
      <div
        className="relative flex w-full items-center justify-center overflow-hidden font-bold tabular-nums leading-none"
        style={{ height: numberHeight, fontSize: numberFontSize, color: numberColor }}
      >
        {animate ? (
          <AnimatePresence mode="popLayout" initial={false}>
            <motion.span
              key={display}
              className="absolute inset-0 flex items-center justify-center"
              initial={{ y: '-100%' }}
              animate={{ y: 0 }}
              exit={{ y: '100%' }}
              transition={SLIDE_TRANSITION}
            >
              {display}
            </motion.span>
          </AnimatePresence>
        ) : (
          <span>{display}</span>
        )}
      </div>
      <span
        className="font-normal leading-none"
        style={{ fontSize: labelFontSize, color: labelColor }}
      >
        {label}
      </span>
    </div>
  );
};
